import { withLazyRoute } from '@/components/Lazy/LazyRouteWrapper'
import React from 'react'

export const InventoryImporterManagement = withLazyRoute(
  React.lazy(() => import('./InventoryImporterManagement')),
  'Loading inventory importer...',
)
